
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { centSum } from '../../global/utils'

@Component
export default class SplitSlider extends Vue {
  @Prop({ type: Number, default: () => 0 })
  private readonly value!: number

  @Prop({ type: Number, default: () => 50 })
  private readonly defaultPercentage!: number

  @Prop({ type: String, default: () => null  })
  private readonly label!: string

  @Prop({ type: String, default: () => null  })
  private readonly description?: string

  @Prop({ type: Boolean, default: false })
  private readonly disabled!: boolean

  get requiredRule() {
    return (v: string) => !!v || 'Value is required'
  }

  get sliderValue(): number {
    return Number(this.value) || this.defaultPercentage
  }

  set sliderValue(val: number) {
    this.$emit('input', val)
  }

  get inverseSliderValue() {
    return centSum([100, -this.sliderValue])
  }

  get distributorPercent() {
    const inverseValue = 100 - this.sliderValue
    return +inverseValue.toFixed(2)
  }

  set distributorPercent(val: number) {
    const inverseValue = 100 - val
    this.sliderValue = inverseValue
  }
}
